/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Form, Typography } from 'antd'
import TagSelectF from '@/i2antdV5/TagSelectF'
import { fetchSystemRolesList } from '@/redux/use/systemRoleSlice'

const { Text } = Typography

const mapStateToProps = (state) => ({
  rolesList: state.use.systemRole.list,
  rolesFetching: state.use.systemRole.fetching
})

const mapDispatchToProps = {
  fetchSystemRolesList
}

function roleIdsFromRecord(record) {
  const roles = record?.roles
  if (!Array.isArray(roles)) return []
  return roles.map((r) => String(r.id)).filter((id) => id !== '')
}

/** 角色标签间距（略大于全局 .ant-tag，避免挤成一团） */
const ROLE_TAG_MODAL_PROPS = {
  style: {
    marginInlineEnd: 12,
    marginBottom: 12,
    paddingInline: 14
  }
}

/**
 * 为权限分配角色（由 WrappedDrawer 注入 form ref）
 */
class PermissionAssignRolesForm extends React.Component {
  static propTypes = {
    form: PropTypes.object,
    rolesList: PropTypes.array,
    rolesFetching: PropTypes.bool,
    fetchSystemRolesList: PropTypes.func,
    record: PropTypes.object
  }

  componentDidMount() {
    const { rolesList, fetchSystemRolesList: load } = this.props
    const afterLoad = () => this.applyInitial()
    if (!rolesList || rolesList.length === 0) {
      load().finally(afterLoad)
    } else {
      afterLoad()
    }
  }

  applyInitial = () => {
    const { record, form } = this.props
    if (!form?.current) return
    form.current.setFieldsValue({
      roleIds: roleIdsFromRecord(record)
    })
  }

  render() {
    const { form, rolesList, rolesFetching, record } = this.props
    const tagOptions = (rolesList || []).map((r) => ({
      id: String(r.id),
      value:
        r.name != null && r.name !== ''
          ? `${r.name}${r.code != null && r.code !== '' ? ` (${r.code})` : ''}`
          : String(r.code ?? r.id)
    }))

    return (
      <Form
        ref={form}
        layout="vertical"
        initialValues={{ roleIds: [] }}
        style={{ width: '100%' }}
      >
        {record ? (
          <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
            权限：{record.name ?? '—'}（{record.code ?? '—'}）
          </Text>
        ) : null}
        <Form.Item
          label="关联角色"
          name="roleIds"
          rules={[{ required: false }]}
          tooltip="点击标签多选关联角色；保存后通过接口更新该权限与角色的绑定。"
          help={
            rolesFetching && tagOptions.length === 0
              ? '角色列表加载中…'
              : !rolesFetching && tagOptions.length === 0
                ? '暂无可用角色'
                : undefined
          }
        >
          <TagSelectF options={tagOptions} modalProps={ROLE_TAG_MODAL_PROPS} />
        </Form.Item>
      </Form>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PermissionAssignRolesForm)
